import { PayloadAction, createSlice } from '@reduxjs/toolkit';

export interface applicationInitialStateI {
  totalPages: number;
  totalRecords: number;
}

const initialState: applicationInitialStateI = {
  totalPages: 0,
  totalRecords: 0
};

export const applicationSlice = createSlice({
  name: 'applicationSlice',
  initialState,
  reducers: {
    setApplicationTotalPages: (
      state: applicationInitialStateI,
      actions: PayloadAction<applicationInitialStateI>
    ) => {
      state.totalPages = actions.payload.totalPages;
      state.totalRecords = actions.payload.totalRecords;
    }
  }
});
